// Utility to format balances for display in accounts and portfolios pages
// If the value rounds to 0.00 (including -0.00), returns '$0.00' (no sign)
// Otherwise, returns value formatted to two decimals, preserving sign and with a dollar sign

export function formatBalanceDisplay(value) {
  if (typeof value !== 'number' || isNaN(value)) return '$0.00';
  // If value rounds to 0.00, show '$0.00' (no sign)
  if (Math.abs(Number(value.toFixed(2))) === 0) return '$0.00';
  // toLocaleString() already prepends '-' for a negative value, so
  // '$' + value.toLocaleString(...) put the sign after the dollar sign
  // (e.g. "$-1,234.50") instead of the conventional "-$1,234.50". Format
  // the magnitude and place the sign and '$' together instead.
  const isNegative = value < 0;
  const magnitude = Math.abs(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${isNegative ? '-' : ''}$${magnitude}`;
}

// Normalize near-zero numeric values to 0 to avoid displaying -0.00 and to treat zero as non-negative
export function normalizeNearZero(value, epsilon = 0.005) {
  if (typeof value !== 'number' || isNaN(value)) return 0;
  return Math.abs(value) < epsilon ? 0 : value;
}